import { serverImage } from './providers/server-image.js';
import { serverText } from './providers/server-text.js';
import { serverVideo } from './providers/server-video.js';
import { serverVision } from './providers/server-vision.js';
import type { ImageProvider, TextProvider, VideoProvider, VisionProvider } from './provider.js';

export const providers: {
  text: TextProvider;
  vision: VisionProvider;
  image: ImageProvider;
  video: VideoProvider;
} = {
  text: serverText,
  vision: serverVision,
  image: serverImage,
  video: serverVideo,
};
